import React from "react";
import { Loader2 } from "lucide-react";

export default function Loader({ text = "Carregando..." }) {
  return (
    <div
      data-testid="app-loader"
      className="min-h-screen flex flex-col items-center justify-center gap-4 bg-slate-50"
    >
      <div className="relative">
        <img src="/logo-clima-branca-icon.png" alt="Clima Branca"
          className="h-14 w-14 rounded-xl object-cover ring-1 ring-slate-200 animate-pulse" />
        <Loader2 className="h-5 w-5 text-[#1e7be0] animate-spin absolute -bottom-1 -right-1" />
      </div>
      <p className="text-sm text-slate-500">{text}</p>
    </div>
  );
}
